import { React } from "react";
const Siniestralidad = ({ nombre, mdstatus, eseditable }) => {
    return(
        <div className=" w-full h-full">
        <iframe className=" w-full h-full border-0"
        src="https://docs.google.com/spreadsheets/d/1FtwcrxNn6sQEtwAWKcvkJEK5sbrPA5H-Pa5_7GtmVaY/edit?gid=701119699#gid=701119699" 
        allowfullscreen sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"></iframe></div>
    )
}
export default Siniestralidad;